import {
  FaUser,
  FaSearch,
  FaJournalWhills,
  FaPlusCircle,
  FaBook,
  FaStar,
  FaKey,
  FaSignOutAlt,
} from "react-icons/fa";
import { CNavBarItemT } from "./navigationType";
import { userLogout } from "src/state/slices/authSlice";
import { setOffcanvasOpen } from "src/state/slices/asideslice";
import AuthorProfile from "src/pages/components/AuthorProfile";
import SearchJournal from "src/pages/components/SearchJournal";
import JoinedJournals from "src/pages/components/JoinedJournal";
import AddPublication from "src/pages/components/AddPublication";
import PublicationList from "src/components/PublicationList";
import MyReviews from "src/pages/components/MyReviews";
import ChangePasswordPage from "src/pages/components/ChangePassword";
import ReviewerRequestsList from "src/pages/components/ReviewerRequestsList";
import ManageReviewer from "src/pages/AssignedPapers";
import { ApprovalStatus } from "src/enums/enums";
const ReviewerNavbar: CNavBarItemT[] = [
  {
    label: "Profile",
    href: "/",
    icon: <FaUser className="custom-icon" />,
    component: AuthorProfile,
  },
  {
    label: "Joined Journals",
    href: "/joined-journals",
    icon: <FaJournalWhills className="custom-icon" />,
    component: JoinedJournals,
  },
  {
    label: "Search Journals",
    href: "/search-journal",
    icon: <FaSearch className="custom-icon" />,
    component: SearchJournal,
  },

  {
    label: "Journal Requests",
    href: "/reviewer-requests",
    icon: <i className="fa fa-tasks custom-icon" />,
    component: ReviewerRequestsList,
  },
  {
    label: "Assigned Papers",
    href: "/assigned-papers",
    icon: <FaSearch className="custom-icon" />,
    component: ManageReviewer,
  },
  {
    label: "Add Publication",
    href: "/add-publication",
    icon: <FaPlusCircle className="custom-icon" />,
    component: AddPublication,
  },
  {
    label: "My Publications",
    href: "/publication-list",
    icon: <FaBook className="custom-icon" />,
    component: PublicationList,
  },

  {
    label: "My Reviews",
    href: "/my-reviews",
    icon: <FaStar className="custom-icon" />,
    component: MyReviews,
  },
  {
    label: "Change Password",
    href: "/change-password",
    icon: <FaKey className="custom-icon" />,
    component: ChangePasswordPage,
  },
  {
    label: "Logout",
    href: "/",
    icon: <FaSignOutAlt className="custom-icon" />,
    onClick(dispatch) {},
  },
];

export function getReviewerNavigation(approval) {
  if (approval == ApprovalStatus.APPROVED) {
    return ReviewerNavbar;
  } else {
    return ReviewerNavbar.filter((item) => {
      return ["/", "/change-password"].includes(item.href);
    });
  }
}
